.footer {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;

  .action {
    margin-left: 10px;
  }

  .extra {
    margin-right: auto;
  }
}
